import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
];

export const protectedRoutes = [
  {
    key: "toilet",
    path: `${APP_PREFIX_PATH}/toilets`,
    component: React.lazy(() => import("views/app-views/List/ToiletList")),
  },
  {
    key: "add-toilet",
    path: `${APP_PREFIX_PATH}/add-toilet`,
    component: React.lazy(() => import("views/app-views/List/AddToilet")),
  },
  {
    key: "view",
    path: `${APP_PREFIX_PATH}/view-toilet`,
    component: React.lazy(() => import("views/app-views/List/ViewPage")),
  },
  {
    key: "reports",
    path: `${APP_PREFIX_PATH}/reports`,
    component: React.lazy(() => import("views/app-views/List/ReportList")),
  },
  {
    key: "reports-details",
    path: `${APP_PREFIX_PATH}/reports-details`,
    component: React.lazy(() => import("views/app-views/List/ReportDetails")),
  },
  {
    key: "new-toilet",
    path: `${APP_PREFIX_PATH}/new-toilet`,
    component: React.lazy(() => import("views/app-views/List/ViewToilets")),
  },
];
